// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3Q5Z8","selected":"Chip_selected__3czZr"};